import { styled } from 'styled-components';

import { _useDispatch, _useSelector } from '@src/state/hooks';
import { useEffect, useState } from 'react';
import useSound from 'use-sound';
import chat from '@src/asset/sound/chat.wav';

import smile from '@src/asset/img/smile.png';
import ChatBox from './ChatBox';
import { ChatMessage } from '@src/lib/types';

import mute from '@src/asset/img/mute.png';

const Container = styled.div<{ chatboxPosition: string }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  max-width: 20rem;

  z-index: 2;
  width: auto;

  ${(props) => (props.chatboxPosition === 'bottom' ? 'top: 0;' : 'bottom: 0;')};
`;

const ChatIcon = styled.img<{ newChatMessage: boolean; chatVisible: boolean }>`
  width: 5rem;
  height: 5rem;
  margin: 1rem;
  // margin-bottom: 18rem;

  pointer-events: auto;
  cursor: pointer;

  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;

  image-rendering: pixelated;

  opacity: ${(props) => (props.chatVisible || props.newChatMessage ? 1 : 0.6)};
`;

const ChatControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const ToggleChatMute = styled.img<{ chatMuted: boolean }>`
  width: auto;
  height: 3rem;
  cursor: pointer;
  opacity: ${(props) => (props.chatMuted ? 0.6 : 1)};

  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`;

type Props = {
  chat: ChatMessage[];
  gameId?: string;
  room?: string;
  chatboxPosition: 'top' | 'bottom';
  initialChatboxVisible: boolean;
  initialChatMuted: boolean;
};

export default function ChatWidget(props: Props) {
  const [chatVisible, setChatVisible] = useState(props.initialChatboxVisible);
  const [newChatMessage, setNewChatMessage] = useState(false);
  const [chatMuted, setChatMuted] = useState(props.initialChatMuted);

  const playerMeta = _useSelector((state) => state.game.playerMeta);
  const playerId = playerMeta ? playerMeta.playerId : '';

  const [playChatSound] = useSound(chat, { volume: 0.25 });

  useEffect(() => {
    if (chatVisible) return;
    if (props.chat.length === 0) return;
    setNewChatMessage(true);
  }, [props.chat]);

  useEffect(() => {
    const latestChatMessage = props.chat[props.chat.length - 1];

    if (
      !chatMuted &&
      latestChatMessage &&
      latestChatMessage.playerId !== playerId
    ) {
      playChatSound();
    }
  }, [props.chat]);

  const toggleChat = () => {
    setChatVisible(!chatVisible);
    setNewChatMessage(false);
  };

  const toggleChatMuted = () => {
    setChatMuted(!chatMuted);
  };

  return (
    <Container chatboxPosition={props.chatboxPosition}>
      {chatVisible && props.chatboxPosition === 'top' && (
        <ChatBox
          room={props.room}
          gameId={props.gameId}
          chatMessages={props.chat}
        />
      )}
      <ChatControlsContainer>
        <ChatIcon
          newChatMessage={newChatMessage}
          chatVisible={chatVisible}
          onClick={toggleChat}
          onFocus={() => console.log('focus')}
          src={smile}
          alt='smile'
        />
        {chatVisible && (
          <ToggleChatMute
            src={mute}
            chatMuted={chatMuted}
            onClick={toggleChatMuted}
          />
        )}
      </ChatControlsContainer>
      {chatVisible && props.chatboxPosition === 'bottom' && (
        <ChatBox
          room={props.room}
          gameId={props.gameId}
          chatMessages={props.chat}
        />
      )}
    </Container>
  );
}
